import React from "react";

const DotMatrixPrint = React.forwardRef(({ data }, ref) => {
    return (
        <div ref={ref}>
            <p>Dot Matrix Print</p>
        </div>
    );
});

export default DotMatrixPrint;
